import Swiper from "swiper/bundle";
import "swiper/css/bundle";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.sfeer_gallery-layout").forEach((layout) => {
        const swiperEl = layout.querySelector(".sfeer-gallery-swiper");
        if (!swiperEl) return;

        new Swiper(swiperEl, {
            slidesPerView: "auto",
            spaceBetween: 16,
            freeMode: { enabled: true, momentum: true },
            grabCursor: true,
            watchOverflow: true,
            navigation: {
                prevEl: layout.querySelector(".swiper-button-prev-custom"),
                nextEl: layout.querySelector(".swiper-button-next-custom"),
                disabledClass: "is-disabled",
            },
            keyboard: { enabled: true, onlyInViewport: true },
            a11y: {
                enabled: true,
                slideLabelMessage: "Foto {{index}} van {{slidesLength}}",
            },
            breakpoints: {
                768: { spaceBetween: 24 },
            },
        });
    });
});
